import { Map } from 'immutable';

import { actionTypes } from './actions';
import initialState from './initialState';

export default function contactsReducer(state = initialState, action) {
  switch (action.type) {
    case actionTypes.REQUEST_START:
      return state
        .set('loading', true)
        .set('data', null)
        .set('error', null)
        .set('tried', null)
        .set('needUpdate', false);
    case actionTypes.REQUEST_SUCCESS:
      return state
        .set('loading', false)
        .set('data', mapContacts(action.payload))
        .set('tried', true);
    case actionTypes.REQUEST_FAILURE:
      return state.set('loading', false).set('error', action.payload);
    case actionTypes.DELETE_REQUEST_START:
      return state.setIn(
        ['data', action.payload.taxCode],
        mapItemLoading(state, action.payload, true),
      );
    case actionTypes.DELETE_REQUEST_SUCCESS:
      return state.set('data', deleteContact(state.get('data'), action.payload));
    case actionTypes.DELETE_REQUEST_FAILURE:
      return state
        .setIn(['data', action.payload.taxCode], mapItemLoading(state, action.payload, false))
        .set('deleteError', action.payload);
    case actionTypes.SET_NEED_UPDATE:
      return state.set('needUpdate', true);
    case actionTypes.SET:
      return state.setIn(['data', action.payload.taxCode], action.payload);
    case actionTypes.DELETE:
      return state.removeIn(['data', action.payload]);
    default:
      return state;
  }
}

const SUCCESSORS_INITIAL_STATE = {
  data: null,
};

export function successorsReducer(state = SUCCESSORS_INITIAL_STATE, action) {
  switch (action.type) {
    case actionTypes.REQUEST_SUCCESS:
      return { ...state, data: action.successors };

    default:
      return state;
  }
}

function mapContacts(contacts = []) {
  let contactsMap = {};

  contacts.forEach((contact) => {
    if (!contactsMap[contact.taxCode]) {
      contactsMap[contact.taxCode] = contact;
    }
  });
  return Map(contactsMap);
}

function deleteContact(data, payload) {
  return data.delete(payload.taxCode);
}

function mapItemLoading(state, payload, loading) {
  const inspection = state.getIn(['data', payload.taxCode]);
  return Object.assign({}, inspection, { loading: loading });
}
